<template>
  <div class="border-black border relative">
    <span class="title absolute top-0 text-white w-full text-center">{{ text }}</span>
    <svg viewBox="0 0 504 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="504" height="96" fill="black"/>
      <circle cx="46" cy="48" r="15" fill="white"/>
      <circle cx="462" cy="48" r="15" fill="white"/>
    </svg>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['en', 'fr'],
  computed: {
    ...mapState(['lang']),
    text () {
      if (this.lang === 'en') {
        return this.en
      } else {
        return this.fr
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  div
    width: 40vw
    height: 40vw
  
  span.title
    top: 2vw
    font-size: 2vw
</style>
